<template>
  <app-page-container title="گزارش">
    <template v-slot:header>
      <v-col cols="1" class="mr-n11 mt-3">
        <v-btn elevation="0" fab color="darkColor" small dark @click="backToCustomReport()">
          <v-icon>mdi-arrow-right mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="4" class="mr-n8">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1">
        <v-btn class="mx-2 mt-3" fab dark small
          @click="exportToExcel(tableHeaders, tableItems, 'text', 'custom_report')" color="darkColor" elevation="0">
          <v-icon dark>mdi-table-arrow-right mdi-18px</v-icon>
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="h-full">
        <v-col cols="12" class="h-full">
          <template>
            <!-- <v-row no-gutters>
              <v-col
                v-for="({text}, index) in tableHeaders"
                :key="index"
                class="grid-header-item flex justify-center items-center"
              >
                {{ text }}
              </v-col>
            </v-row> -->
            <!-- <section class="grid-container">
              <v-virtual-scroll
                :bench="15"
                :items="filterdTableItems"
                height="100%"
                item-height="50"
                class="h-full"
              >
                <template v-slot:default="{ item,index }">
                  <v-row
                    no-gutters
                    :key="item"
                    class="grid-item"
                    :class="{'grid-item-even':index%2===0}"
                  >
                    <v-col
                      v-for="({value}, index) in tableHeaders"
                      :key="index"
                      class="text-center grid-item-col flex justify-center items-center"
                    >
                      {{ item?.[value] }}
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                </template>
</v-virtual-scroll>
</section> -->
            <v-data-table fixed-header hide-default-header height="calc(82vh - 30px)" :headers="tableHeaders"
              :items="tableItems" :items-per-page="tableItems.length" :search="searchTitle" :hide-default-footer="true"
              multi-sort id="mTable" class="elevation-0 tt" virtual-scroll :virtual-scroll-item-height="48"
              :virtual-scroll-bench="50">
              <template v-slot:header="props">
                <app-group-table-header has-group-by-option :headers="props.props.headers" @sort="props.on.sort"
                  @group="props.on.group" />
              </template>
              <template v-slot:no-data>
                <span>اطلاعاتی جهت نمایش وجود ندارد</span>
              </template>
            </v-data-table>
          </template>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <v-dialog width="450" v-model="parameterModal" persistent>
        <v-card>
          <v-row no-gutters>
            <v-col cols="12" class="modal-header py-2">
              <v-row no-gutters>
                <v-spacer></v-spacer>
                <v-icon color="darkColor">mdi-magnify</v-icon>
                <span class="modal-title-text mr-2">جستجو</span>
                <v-spacer></v-spacer>
              </v-row>
            </v-col>
          </v-row>
          <v-card-text class="mt-12">
            <v-row>
              <v-col cols="12" v-for="(item, index) in reportParaMeters" :key="item.id" class="mt-n8">
                <v-text-field v-if="item.typeId == 2" type="text" v-model="item.value" dense clearable
                  clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" :label="item.lable"
                  class="input-label" :prepend-inner-icon="item.icon"></v-text-field>
                <v-text-field v-if="item.typeId == 3" type="text" v-model="item.value" dense
                  @keypress="isNumber($event)" clearable clear-icon="mdi-close-circle-outline" outlined
                  v-on:keyup.enter="search()" :label="item.lable" class="input-label"
                  :prepend-inner-icon="item.icon"></v-text-field>
                <v-autocomplete v-if="item.typeId > 4" :items="item.items" no-data-text="اطلاعاتی وجود ندارد" dense
                  outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                  :label="item.lable" v-model="item.value" autocomplete="off"
                  :prepend-inner-icon="item.icon"></v-autocomplete>
                <v-text-field v-if="item.typeId == 1" type="text" outlined :id="`usermoveFromStationTime ${item.id}`"
                  :ref="`usermoveFromStationTime ${item.id}`" dense clearable autocomplete="off"
                  @click:clear="clearDateTime(index)" clear-icon="mdi-close-circle-outline" v-model="item.tempValue"
                  @focus="item.showDate = true" @click="item.showDate = true" :label="item.lable"
                  prepend-inner-icon="mdi-calendar-range mdi-18px">
                  <template slot="append">
                    <v-icon @click="item.showDate = true" class="calender-background ml-n3 mt-n2" color="white">
                      mdi-calendar-range mdi-18px
                    </v-icon>
                  </template>
                </v-text-field>
                <date-picker v-if="item.typeId == 1" :show="item.showDate" simple v-model="item.value" type="datetime"
                  @open="onOpen" @change="dateTimeChange(index)" :editable="true" format="YYYY-MM-DDTHH:mm:ss"
                  display-format="HH:mm:ss jYYYY/jMM/jDD" custom-input="#moveFromStationTime-moveFromStationTime"
                  @close="item.showDate = false" />
                <v-checkbox class="mt-n3" v-if="item.typeId == 4" v-model="item.value" :label="item.lable"></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="mt-2">
            <v-spacer></v-spacer>
            <v-btn color="darkColor" @click="search()" dark rounded class="normal-letter-spacing px-12">
              ثبت
            </v-btn>
            <v-btn rounded color="darkColor" outlined @click="cancelSearch()" class="normal-letter-spacing px-10">
              انصراف
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
        :snakIcon="snakIcon"></alert-component>
    </template>
  </app-page-container>
  <!-- <div>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val" contain>
          <v-row>
            <v-col cols="3">
              <v-img
                :src="tableTitleImage.val"
                contain
                max-height="14vh"
                max-width="27vh"
              >
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">گزارش</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
          </v-row>
          
        </v-img>
      </v-col>
    </v-row>
  </div> -->
</template>
<script>
import { utils, write } from 'xlsx';
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import AppGroupTableHeader from '@/components/app/table/groupableHeader.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import CustomReportMixin from '@/Mixins/Report/CustomReportMixin';
import ReportMixin from '@/Mixins/Report/ReportMixin';
import CustomeReportItemsHelper from '@/Helpers/Report/Amar/CustomeReportItemsHelper.js';
import ExcelGeneratorHelper from '@/Helpers/Excel.generator.helper';
export default {
  name: 'CustomReportAmarItems',
  title: 'گزارش سفارشی آمار',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    AlertComponent,
    AppPageContainer,
    AppGroupTableHeader,
  },
  mixins: [
    ShearedMixin,
    CustomReportMixin,
    CustomeReportItemsHelper,
    snackBar,
    ShearedHelper,
    ReportMixin,
    ExcelGeneratorHelper,
  ],
  created() {
    this.$root.$refs.CustomReportAmarItems = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {};
  },
  methods: {
    mounte: function () {
      this.customReportId = this.$route.params.id;
      this.getCustomReportParameterFunction(Number(this.customReportId));
    },
    excelExport: function () {
      const setData = () => {
        let data = [];
        let info = [];
        for (const item of this.tableHeaders) {
          info.push(item.text);
        }
        data.push(info);
        for (const item of this.tableItems) {
          let info2 = Object.values(item);
          data.push(info2);
        }
        return {
          data,
        };
      };
      const createBookSheet = () => {
        const wb = utils.book_new();
        const ws = utils.aoa_to_sheet(data);
        const range = utils.decode_range(ws['!ref']);
        for (let i = 0; i <= range.e.c; i++) {
          const cell = utils.encode_cell({ r: 0, c: i });
          ws[cell].s = { color: 'red' };
        }
        utils.book_append_sheet(wb, ws, 'Sheet1');
        const wbout = write(wb, {
          bookType: 'xlsx',
          bookSST: true,
          type: 'binary',
          defaultEncoding: 'utf-8',
        });
        return { wbout };
      };
      const createBlobInstance = () => {
        const fileBuffer = new ArrayBuffer(wbout.length);
        const view = new Uint8Array(fileBuffer);
        for (let i = 0; i < wbout.length; i++) {
          view[i] = wbout.charCodeAt(i) & 0xff;
        }
        const blob = new Blob([fileBuffer], {
          type: 'application/octet-stream',
        });
        return {
          blob,
        };
      };
      const downloadLink = () => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = 'test.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      };
      const { data } = setData();
      const { wbout } = createBookSheet();
      const { blob } = createBlobInstance();
      downloadLink();
    },
  },
};
</script>
<style scoped lang="scss">
.h-full {
  height: 100%;
}

.grid-header-item {
  height: 3rem;
  font-weight: 600;
  font-size: 1rem;
}

.grid-container {
  & {
    height: calc(100% - 50px);
  }

  .grid-item {
    height: 3rem;

    &-even {
      background-color: var(--background-color);
    }

    &-col {
      font-weight: 500;
      font-size: 14px;
    }
  }
}
</style>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}

>>>.tt tbody tr:nth-of-type(even) {
  background-color: var(--background-color) !important;
}

>>>td {
  cursor: auto !important;
  user-select: auto !important;
  -webkit-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  -khtml-user-select: auto !important;
  color: black !important;
}

>>>span {
  user-select: auto !important;
  -webkit-user-select: auto !important;
  -moz-user-select: auto !important;
  -ms-user-select: auto !important;
  -khtml-user-select: auto !important;
}
</style>
